import {
    IElementQuestionAnswer,
    IElementQuestionnaireWithAnswers,
    IQuestionAnswerType,
} from '../incase-domain/elements/base/questionElementBase';

export const getAnswer = (
    index: number,
    element: IElementQuestionnaireWithAnswers,
    codebookAnswer?: IElementQuestionAnswer
): IElementQuestionAnswer => {
    if (codebookAnswer) {
        return codebookAnswer;
    }
    return element.answers[index];
};

export const getCodeBookAnswerType = (
    element: IElementQuestionnaireWithAnswers,
    codebookEntryId: string | undefined
): IQuestionAnswerType => {
    return (
        (codebookEntryId && element.answers.find((a) => a.codebookEntryId === codebookEntryId)?.type) ||
        getCodebookDefaultAnswerType(element)
    );
};

export const getCodebookDefaultAnswerType = (element: IElementQuestionnaireWithAnswers): IQuestionAnswerType => {
    if ('defaultCodebookAnswerType' in element) {
        return element.defaultCodebookAnswerType as IQuestionAnswerType;
    }

    return 'incorrect';
};

export const setCodebookAnswerType = (
    codebookAnswer: IElementQuestionAnswer,
    highlightedElement: IElementQuestionnaireWithAnswers,
    highlightedElementChangeHandler: {single: (field: keyof IElementQuestionnaireWithAnswers | string, value: unknown) => void},
    nextTypeMapping: Record<string, IQuestionAnswerType>
): void => {
    const baseType = getCodebookDefaultAnswerType(highlightedElement);

    const answer = highlightedElement.answers.find((a) => a.codebookEntryId === codebookAnswer.codebookEntryId);

    let newAnswers = [...highlightedElement.answers];

    if (!answer) {
        const type = nextTypeMapping[baseType];
        newAnswers = [...newAnswers, {...codebookAnswer, type}];
    } else {
        const newType = nextTypeMapping[answer.type];
        if (newType === baseType && !answer.comment) {
            newAnswers = newAnswers.filter((a) => a.codebookEntryId !== codebookAnswer.codebookEntryId);
        }
        newAnswers = newAnswers.map((a) => (a.codebookEntryId === codebookAnswer.codebookEntryId ? {...a, type: newType} : a));
    }

    highlightedElementChangeHandler.single('answers', newAnswers);
};

export const setCodebookAnswerComment = (
    codebookAnswer: IElementQuestionAnswer,
    highlightedElement: IElementQuestionnaireWithAnswers,
    highlightedElementChangeHandler: {single: (field: keyof IElementQuestionnaireWithAnswers | string, value: unknown) => void},
    comment: string
): void => {
    const baseType = getCodebookDefaultAnswerType(highlightedElement);
    const answer = highlightedElement.answers.find((a) => a.codebookEntryId === codebookAnswer.codebookEntryId);

    let newAnswers = [...highlightedElement.answers];

    if (!answer) {
        if (!comment) return;
        newAnswers = [...newAnswers, {...codebookAnswer, type: baseType, comment}];
    } else {
        if (answer.type === baseType && !comment) {
            newAnswers = newAnswers.filter((a) => a.codebookEntryId !== codebookAnswer.codebookEntryId);
        }
        newAnswers = newAnswers.map((a) => (a.codebookEntryId === codebookAnswer.codebookEntryId ? {...a, comment} : a));
    }

    highlightedElementChangeHandler.single('answers', newAnswers);
};
